import React, { useEffect, useRef, useState } from "react";
import "../styles/AboutSection7.css";
//import "../styles/YourCSSFile.css"; // Replace with your actual CSS filename

const AboutSection7 = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.3 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);

  return (
    <div ref={sectionRef} className="A_sec7">
      <h2 className={`A_sec7_heading ${isVisible ? "fade-in-up" : ""}`}>
        Get to Know Our Global Team
      </h2>

      <div className="A_sec7_one">
        {[
          { name: "Mobeena Sheik", role: "CEO", img: "images/Mobeena.png" },
          {
            name: "Akbar Sheik",
            role: "CO-Founder",
            img: "images/Akbar_img2.png",
          },
          {
            name: "Vijay Kumar",
            role: "Director Operations",
            img: "images/Vijay_img3.png",
          },
          {
            name: "Phillip Van Poole",
            role: "SVP(Business Development)",
            img: "images/phillip_van_poole.png",
          },
          {
            name: "Lakshmi Sruthi",
            role: "HR Manager",
            img: "images/Sruthi_img4.png",
          },
          {
            name: "Supriya Ingole",
            role: "Project Manager",
            img: "images/Supriya_img5.png",
          },
          {
            name: "Ashutosh Tiwari",
            role: "Technical Architect",
            img: "images/Ashutosh_img6.png",
          },
          {
            name: "Vikash Dubey",
            role: "Senior Software Engineer",
            img: "images/Vikas_img7.png",
          },
          {
            name: "Harrison Atuokwu",
            role: "Content Writer",
            img: "images/Harrison_img8.png",
          },
        ].map((member, i) => (
          <section
            key={i}
            className={`A_sec7_one_card ${
              isVisible ? `animated-card delay-${i}` : ""
            }`}
          >
            <img className="A_akbar_img" src={member.img} alt={member.name} />
            <h5>{member.name}</h5>
            <p>{member.role}</p>
          </section>
        ))}
      </div>
    </div>
  );
};

export default AboutSection7;
